import * as React from 'react';

var _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgXrp = function SvgXrp(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M0 60C0 26.863 26.863 0 60 0s60 26.863 60 60-26.863 60-60 60S0 93.137 0 60"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M85.057 32.318H95.27l-21.287 19.95a20.773 20.773 0 0 1-27.873 0l-21.286-19.95h10.214L51.17 47.4a13.06 13.06 0 0 0 17.66 0zM34.943 87.681H24.73l21.382-20.045a20.57 20.57 0 0 1 27.872 0L95.366 87.68H85.152L68.925 72.41a13.06 13.06 0 0 0-17.659 0z"
    })));
};

export { SvgXrp as ReactComponent };
//# sourceMappingURL=XRP.svg.es.js.map
